import { render, staticRenderFns } from "./ReceiverInfo.vue?vue&type=template&id=57ecff06&scoped=true&"
import script from "./ReceiverInfo.vue?vue&type=script&lang=js&"
export * from "./ReceiverInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverInfo.vue?vue&type=style&index=0&id=57ecff06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ecff06",
  null
  
)

export default component.exports